<success-screen bgImage="coinsCrypto" class="bp-modal mod-lg">
  <bp-modal-header header class="font-semibold" [title]="'success_alt_text' | translate">
    <a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div content>
    <div class="success-content-inner">
      <span class="price-alert-button" (click)="addPriceAlert()">
        <svg-inline
          class="icon-status-forward price-alert-bell-icon"
          src="assets/images/icons/icon-pricealert-add.svg"
          [alt]="'forward_alt_text' | translate" />
      </span>
      <ng-lottie width="190px" height="190px" [options]="successAnimationOptions"></ng-lottie>
      @if (!isLeveragedToken) {
        <div class="success-headline mb-15">{{
          offer?.getType() + "_successful" | translate
        }}</div>
      }
      @if (isLeveragedToken) {
        <div class="success-headline mb-15">{{
          "leveraged_token_success_title" | translate
        }}</div>
      }
      @if (!isIndexTrade() && !isLeveragedToken) {
        <p
          class="text-center mb-15 font-size-17 translation-helper"
          >
          <span>{{ offer?.getType() + "_success_text" | translate }}</span>
          <br />
          <strong>
            {{
            (offer?.bestFeeOptIn ? offer?.getAmountAssetBfc() : offer?.getAmountTradable())
            | tradable_precision_symbol
            : {
            id: offer?.getCurrencyId(),
            currencies: [getTradable()],
            addName: true,
            dustThreshold: 0.0001
          }
          }}
        </strong>
        @if (isToken()) {
          {{ "fma_of" | translate: null : true }}
          {{ getTradable().getName() }}
        }
        {{ "for_success_screen" | translate }}
        <strong>
          {{
          (offer?.bestFeeOptIn ? offer?.getAmountFiatBfc() : offer?.getAmountFiat())
          | fiat_precision_symbol: { id: offer?.getFiatId(), currencies: [getFiat()], symbol: true }
          }}
        </strong>
        &#64;
        <strong>
          {{
          1
          | tradable_precision_symbol
          : {
          id: offer?.getCurrencyId(),
          currencies: [getTradable()],
          addName: true,
          removePrecision: true
        }
        }}
        =
        {{
        (offer?.bestFeeOptIn ? offer?.getPriceBfc() : offer?.getPrice())
        | fiat_precision_symbol
        : { id: offer?.getFiatId(), currencies: [getFiat(), getTradable()], symbol: true }
        }}
      </strong>
    </p>
  } @else {
    @if (isIndexTrade()) {
      <p class="text-center mb-15 font-size-17 translation-helper">
        <span>
          {{
          offer?.getType() + "_index_success"
          | translate
          : [
          offer?.getAmountFiat()
          | fiat_precision_symbol
          : {
          id: offer?.getFiatId(),
          currencies: [getFiat()],
          symbol: true
          },
          getTradable().getName()
          ]
          : false
          }}
        </span>
      </p>
    }
    @if (isLeveragedToken) {
      <p class="text-center mb-15 font-size-17 translation-helper">
        <span>
          {{
          "leverage_token_success_subtext_" + leveragedTokenSuffix
          | translate
          : [
          getTradable().getName(),
          offer?.getAmountFiat()
          | fiat_precision_symbol
          : {
          id: offer?.getFiatId(),
          currencies: [getFiat()],
          symbol: true
          },
          offer?.getAmountTradable()
          | tradable_precision_symbol
          : { id: offer?.getCurrencyId(), symbol: true }
          ]
          : false
          }}
        </span>
      </p>
    }
  }

  <ng-container *bfc>
    @if (showBfcInfoBox()) {
      <div class="additional-gain">
        <span class="bpi__asset-placeholdericon bpi__asset-best font-size-24 mr-10"></span>
        <span class="description">
          {{
          getBfcInfoText()
          | translate
          : [
          offer?.getAssetBonusBfc()
          | tradable_precision_symbol
          : {
          id: getTradable().getId(),
          ignorePrecision: true,
          addName: true
        }
        ]
        }}
      </span>
    </div>
  }
</ng-container>

<!-- Info box -->
<span class="center-block mb-20">
  <instant-trade-bonus [amount]="itbAmount" [step]="ITBStep.SUCCESS" [showLoading]="showItbLoading">
  </instant-trade-bonus>
</span>

<!-- Tax withholding info -->
@if (taxWithheld; as tax) {
  <tax-success-amount-label-ui [taxWithheld]="tax"></tax-success-amount-label-ui>
}
</div>
<!-- Share and portfolio buttons -->
<div class="text-center center-block ml-80 mr-80">
  <button (click)="shareTrade()" class="btn btn-primary btn-success-modal mb-10" type="button">
    <svg-inline
      class="icon-status-forward mr-10 share-icon"
      src="assets/images/icons/icon-share.svg"
      [alt]="'forward_alt_text' | translate" />
    <strong>{{ "share_this_trade_button_title" | translate }}</strong>
  </button>
  <button
    (click)="goToPortfolio()"
    class="btn btn-primary btn-success-modal mod-middle button-weight"
    type="button">
    <strong>{{ "go_to_portfolio" | translate }}</strong>
  </button>
</div>
</div>
</success-screen>
